// Triggers a browser download from an axios call that returns a blob response
// (i.e. the api method must be called with { responseType: 'blob' } already
// baked in — see e.g. poApi.exportExcel, grnApi.exportExcel, etc).
export async function downloadReport(apiFn, filename) {
  const res = await apiFn();
  const mime = filename.endsWith('.pdf')
    ? 'application/pdf'
    : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const blob = new Blob([res.data], { type: mime });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
}